import React from "react";

const LeftArrowIcon = () => {
 return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="15.5" transform="rotate(180 16 16)" fill="white" stroke="#3249D7"/>
    <path d="M17.8672 9.5874L19 10.7351L13.9414 15.7937L19 20.8523L17.8672 22L11.6609 15.7937L17.8672 9.5874Z" fill="#3249D7"/>
    </svg>    
);
};

export default LeftArrowIcon
